import React from "react";

import "../../../home/home.css";
import PartnersData from "./PartnersData";


const Partners = () => {

    return (
        <>
            <section className="insidePage" style={{ backgroundColor: '#2fb8e7' }}>
                <div className="container" data-aos="fade-up" data-aos-duration="500" data-aos-delay="0.9s">
                    <p className="text-white">
                        <span className='title text-center'>Our Technology Partners</span> 
                        <span className='text-center subTitle'>
                            Trusted by big one and loved by everyone
                        </span>
                    </p>            
                </div>
            </section>

            <main className="main">
                <section id="clients" className="clients">
                    <div className="col-lg-12 text-center">
                        {/* <header className="section-header">
                            <p className="blue-un">Technology Partners</p>
                        </header> */}
                    </div>
                    <div className="container" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="0.9s">
                        <div className="row gy-4">
                            <PartnersData/>
                        </div>
                    </div>
                </section>
            </main>
            
        </>
    );
};

export default Partners;
